import axios from 'axios';
import { toRefs } from 'vue';
import { utils } from '@cpc/comment-sdk-common';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import wv from '@cpc/comment-sdk-jsapi';
import { JsApiResponseResult } from '@cpc/comment-sdk-types/src/wv';
import { SdkError } from '@cpc/comment-sdk-types/src/sdk';

const brandName = window.atob('b3Bwbw==');
const { createError, sleep } = utils;
const { env, docId, source, documentMeta, systemId } = toRefs(useGlobalState());

const getBrowserAccess = function (env: string) {
  // const API = window[brandName] && window[brandName].API || {};

  // if (API.feedsAccess) {
  //   return API.feedsAccess;
  // }

  const apiEnvMaps: {
    [key: string]: string;
  } = {
    production: '//ibrowser.feeds.heytapmobi.com/',
    test: 'http://i.test.browserproxy.wanyol.com',
    dev: '//i.test.browserproxy.wanyol.com',
    development: '//i.test.browserproxy.wanyol.com',
  };

  return apiEnvMaps[env] || '/';
};

const fetchInstance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
});

fetchInstance.interceptors.request.use(
  async function (config) {
    const method = config?.method?.toLowerCase();

    const session = wv.isMethodValid('getSession') ? await wv
      .asyncInvoke('getSession')
      .then((res) => {
        if (res.code === 0) {
          return window.btoa(JSON.stringify(res.data));
        }
        return '';
      })
      .catch((error) => {
        if (error.code === 23333) {
          return '';
        } else {
          console.error(error);
        }
      }) : wv.invoke('User.getSession');

    const getFeedssession = async function () {
      return Promise.race([
        sleep(500).then(() => {
          const res: JsApiResponseResult<string> = {
            code: 30009,
            data: '',
            message: 'getFeedSession timeout',
          };

          return res.data;
        }),
        !wv.isMethodValid('User.getFeedsSession')
          ? wv.getIflowSession() || (import.meta.env.DEV ? 'zhangyy_test' : '')
          : new Promise((resolve, reject) => {
            resolve(wv.invoke<JsApiResponseResult<boolean>>('User.getFeedsSession'));
            reject((error: SdkError) => {
              if (error.code === 23333) {
                return 'zhangyy_test';
              } else {
                console.error(error);
                throw error;
              }
            });
          }),
      ]);
    };


    const feedssession = await getFeedssession();


    const baseConf = {
      f: 'json',
      route: 'gray',
      feedssession,
      session,
      docId: docId.value,
      source: documentMeta.value.dataSource || source.value,
      businessType: systemId.value.toUpperCase(),
    };

    if (method === 'post') {
      config.data = Object.assign({}, config.data || {}, baseConf);
    } else if (method === 'get') {
      config.params = Object.assign({}, config.params || {}, baseConf);
    }

    config.baseURL = getBrowserAccess(env.value);


    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

fetchInstance.interceptors.response.use(
  function (response) {
    let error;
    let data;
    const res = response.data;

    switch (res.ret) {
      case 0:
        data = res.result || {};
        break;
      case 1400:
        error = createError(1400, '请求参数错误');
        break;
      case 1401:
        error = createError(1401, '鉴权失败');
        break;
      case 1403:
        error = createError(1403, 'Session过期');
        break;
      case 1500:
        error = createError(1500, '内部服务错误');
        break;
      case 1504:
        error = createError(1504, '第三方资源请求超时');
        break;

      default:
        error = createError(
          res.code || -1,
          res.msg || res.message || res.desc || 'unknown mistake',
        );
        break;
    }

    return error ? Promise.reject(error) : Promise.resolve(data);
  },
  function (error) {
    return Promise.reject(error);
  },
);

interface BlackRelationResInterface {
  has_block: boolean;
  be_block: boolean;
}

export function getCommentBlackRelation<T = BlackRelationResInterface>(params = {}): Promise<T> {
  return fetchInstance.get('feedsInteract/getCommentBlackRelation', {
    params
  });
}
